export default __webpack_public_path__ + "static/media/chat_inactive.0694b526.svg";